export default __webpack_public_path__ + "static/media/readiness_icon4.242249f3.svg";